import * as R from 'remeda'

import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { type Brand9segsInBrandGroup } from '~/gql/graphql'

export const pathKey = 'customerAnalysis' satisfies PathKey

export type ScrollHash = '5segs' | '9segs'

export type DisplayRowId = Brand9segsInBrandGroup['id'] | 'average' | 'max'

type CalcItem<CountKey extends string, RatioKey extends string> = {
  counts: Record<CountKey, number>
  ratios: Record<RatioKey, number>
}

export const calcAverage = <CountKey extends string, RatioKey extends string>(
  data: CalcItem<CountKey, RatioKey>[],
) =>
  0 < data.length
    ? {
        counts: R.mapValues(
          data[0].counts,
          (_, key) =>
            R.sumBy(data, (brand) => brand.counts[key as unknown as CountKey]) /
            data.length,
        ),
        ratio: R.mapValues(
          data[0].ratios,
          (_, key) =>
            R.sumBy(data, (brand) => brand.ratios[key as unknown as RatioKey]) /
            data.length,
        ),
      }
    : null

export const calcMax = <CountKey extends string, RatioKey extends string>(
  data: {
    counts: Record<CountKey, number>
    ratios: Record<RatioKey, number>
  }[],
) =>
  0 < data.length
    ? {
        counts: R.mapValues(data[0].counts, (_, key) =>
          Math.max(
            ...data.map((brand) => brand.counts[key as unknown as CountKey]),
          ),
        ),
        ratio: R.mapValues(data[0].ratios, (_, key) =>
          Math.max(
            ...data.map((brand) => brand.ratios[key as unknown as RatioKey]),
          ),
        ),
      }
    : null
